module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc01"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle",
    attrs: {
      "id": "p_1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction: Catholic Social Doctrine and Political Philosophy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part01"
    }
  }, [_c('i', [_vm._v("Part One The Human Person, the Political Community, and the Common Good")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("1. The Dignity of the Human Person, Human Rights, and Natural Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Meaning of the Common Good")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Seeking the Common Good through Virtue and Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Seeking the Common Good through Justice and Social Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Seeking the Common Good through Law and Public Policy: Same-Sex Marriage, the Life Questions, and Biotechnology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Two Civil Society and the Common Good: Three Mediating Institutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Civil Society and the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Civil Society, the Family, and the Principle of Subsidiarity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Civil Society, the Catholic University, and Liberal Education")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Three Private Property and the Universal Destination of Goods")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Economy, Work, Poverty, and Immigration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Safeguarding and Sustaining the Environment")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Four The International Community and Justice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The International Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Just-War Principles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Tension between Catholic Social Doctrine and the Proponents of Religion as a Private Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Pope Benedict XVI's "), _c('i', [_vm._v("Caritas in veritate")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "p_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "p_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 72
// module chunks = 0